// Inspired by: https://stackoverflow.com/questions/62522994/how-do-i-lower-the-rate-of-http-requests-triggered-due-to-onchange-for-material

import { useState } from 'react';
import debounce from '../utils/debounce';

export const useDebounce = <T, K>(onChange: (props: T) => K, changeTimeout = 1000) => {
    const [invokeDebounce] = useState(() =>
        debounce(onChange, changeTimeout)
    );

    return invokeDebounce;
};
